<!--Forge widget-->
<div class="forge-content" [style.width]="'100%'" [style.height]="'100%'" [style]="containerStyle" #htmlContent>
  <div *ngIf="!isLoading()" [style]="blockStyle">
    @if (richTitle && showTitle) {
    <app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
    } @else {
    <p [style]="titleStyle" *ngIf="showTitle">{{ title }}</p>
    }
    <span class="error" *ngIf="error">{{ error }}</span>
    <div class="forge-viewer-container" #forgeContent>
      <adsk-forge-viewer [viewerOptions]="viewerOptions"> </adsk-forge-viewer>
    </div>
  </div>

  <app-widget-loading *ngIf="isLoading()" [graphType]="widget?.graphType"></app-widget-loading>
</div>